import { assert } from "../../asserts/index.ts";
import type { ContentLanguage } from "../../schemas/index.ts";

export const getFallbackLanguageCodesCreate = ({
  primaryLanguageCode,
  contentLanguages,
}: {
  primaryLanguageCode: string;
  contentLanguages: ReadonlyArray<ContentLanguage>;
}) => {
  const getFallbackLanguageCodes = (languageCode?: string): string[] => {
    if (!languageCode || languageCode === primaryLanguageCode) {
      return [primaryLanguageCode];
    }

    const activeContentLanguage = contentLanguages.find(({ language: { code } }) => code === languageCode);
    if (!activeContentLanguage) {
      // this is likely to happen during loading
      // "flash of untranslated content"
      return [primaryLanguageCode];
    }

    if (activeContentLanguage.baseCode) {
      const baseContentLanguage = contentLanguages.find(({ code }) => code === activeContentLanguage.baseCode);
      assert(baseContentLanguage, `Base content language '${activeContentLanguage.baseCode}' not found.`);
      return [languageCode, ...getFallbackLanguageCodes(baseContentLanguage.language.code)];
    }

    return [languageCode, primaryLanguageCode];
  };

  return getFallbackLanguageCodes;
};

export type GetLanguageFallbackCodes = ReturnType<typeof getFallbackLanguageCodesCreate>;
